<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog work_order_feedback_finish_form"
        title="实施结束"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <el-form
                ref="workOrderFeedBackFinishForm"
                :model="workOrderFeedBackFinishForm"
                :rules="workOrderFeedBackFinishFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="实施结束时间" prop="end_date">
                    <div class="flex_wrap">
                        <el-date-picker
                        v-model="workOrderFeedBackFinishForm.end_date"
                        format="yyyy-MM-dd"
                        placeholder="请选择时间"
                        size="small"
                        type="date"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                        <span class="line"></span>
                        <el-select v-model="workOrderFeedBackFinishForm.end_time">
                            <el-option :value="1" label="上午"></el-option>
                            <el-option :value="2" label="下午"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { workOrderFeedbackEnd } from "@/api";
export default {
    name: "WorkOrderFeedBackFinish",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        workorder_num: {
            type: String,
            default: ""
        },
        workorder_start_date: "",
        workorder_start_time: {
            type: Number,
            default: 1
        }
    },
    data() {
        const validateEndDate = (rule, value, callback) => {
            const end_date = value;

            if (!end_date) {
                callback(new Error('请选择实施结束时间'));
            } else if (this.workorder_start_date && end_date && (new Date(end_date) < new Date(this.workorder_start_date))) {
                callback(new Error('实施结束时间不能早于实施开始时间'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            workOrderFeedBackFinishForm: {
                end_date: "",
                end_time: 1,
            },
            workOrderFeedBackFinishFormRules: {
                end_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }, { validator: validateEndDate, trigger: 'change' }],
            },
        };
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderFeedBackFinishForm.validate((valid) => {
                if (valid) {
                    if(this.workorder_start_date == this.workOrderFeedBackFinishForm.end_date && Number(this.workOrderFeedBackFinishForm.end_time) < Number(this.workorder_start_time) ) return this.$message.error("实施结束时间段不能早于实施开始时间时间段")
                    const params = {
                        workorder_id: this.workorder_id,
                        workorder_num: this.workorder_num,
                        ...this.workOrderFeedBackFinishForm,
                    };
                    workOrderFeedbackEnd(params).then((res) => {
                        if (res.code === 200) {
                                this.$message.success(res.message || "提交成功");
                                this.$emit("update:dialogVisible", false);
                                this.$emit("refreshList");
                            }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.work_order_feedback_finish_form {
    .flex_wrap {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        .el-input__inner {
            padding: 0 12px;
            border-color: rgb(217, 217, 217);
            border: none;
            color: rgb(51, 51, 51);
            font-size: 14px;
            padding-left: 30px !important;
        }
        .el-select {
            width: 60px !important;
            flex-shrink: 0;
            .el-input__inner {
                padding: 0 !important;
            }
        }
    }
}

</style>
